// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-player-container {
  position: relative;
  margin-top: 55px;
  cursor: pointer;
}

.audio-player-container>* {
  margin: 0;
}

.audio-ctrl-btn {
  /* background-color: #E2E8EE; */
  border: solid 1px #63768a;
  background-color: #f2f5f8;
  color: #243547;
  width: 60px;
  margin: 0 5px;
  font-size: 12px;
}

.audio-ctrl-btn-dropdown {
  display: flex !important;
  flex-direction: row !important;
  width: 140px !important;
  height: 58px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400 !important;
}

.audio-ctrl-container-right>.nds-dropdown>.nds-field__info {
  opacity: 0;
  height: 0px;
  width: 0px;
}

.audio-ctrl-btn:hover {
  border: solid 1px #63768a;
  background-color: #e2e8ee;
}

.audio-ctrl-btn-tooltip-body {
  /* width: 58px; */
  /* height: 31px; */
  padding: 8px 12px;
  background-color: #e4e4e4;
  color: #243547;
  font-size: 12px;
}

/* .audio-ctrl-btn-tooltip-base {
  border: 1px solid gray;
} */

.audio-ctrl-btn-center {
  border: solid 1px #32475e;
  background-color: #32475e;
  width: 60px;
  color: #FFFFFF;
  margin: 0 5px;
  font-size: 12px;
}

.audio-ctrl-btn-center:hover,
.play-btn:hover {
  border: solid 1px #243547;
  background-color: #243547;
}

.sections-dropdown-label {
  opacity: 0;
  height: 0px;
  width: 0px;
}

.play-btn {
  width: 180px;
  font-size: 12px;
  border: solid 1px #32475e;
  background-color: #32475e;
  color: #FFFFFF;
}

.pause-btn {
  width: 180px;
  font-size: 12px;
  background-color: #E2E8EE;
  color: #243547;
  border: 1px solid #243547;
}

.pause-btn:hover {
  border: solid 1px #63768a;
  background-color: #ced7e0;
}

.audio-ctrl-btn,
.audio-ctrl-btn-center>* {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
}

.audio-ctrl-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px auto;
}

.audio-slider {
  border: 0;
  width: 100%;
  padding: 40px 0px 0px 0px;
  background: transparent;
}

.audio-slider-label {
  width: 100%;
  font-weight: 400;
}

.audio-slider-label-span-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.tooltip-label-span {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.tooltip-label-span-timestamp {
  font-weight: bold;
}

.tooltip-label-container {
  margin: 0px;
  padding: 0 10px;
  text-align: left;
  font-size: 14px;
}

.timeStampContainer {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}

.tickmark-btn-container {
  position: absolute;
  top: 10px;
  height: 16px;
  width: 100%;
  z-index: 5;
}

.tickmark-btn {
  /* height: 15px;
  width: 10px; */
  position: absolute;
  top: -1px;
  width: 12px;
  height: 10px;
  padding: 0px;
  /* border: none; */
  font-size: 15px;
  color: transparent;
  /* background-color: #BDC4CA; */
  /* line-height: 15px; */
  overflow: hidden;
  /* border-radius: 2px; */
  z-index: -1;
  border-radius: 2px;
  border: solid 1px #475b70;
  background-color: #ced7e0;
}

.tickmark-btn:hover {
  border: solid 1px #475b70;
  background-color: #63768a;
}

.tickmark-btn-active {
  border: solid 1px #196263;
  background-color: #abe0e0;
}

.tickmark-btn-text {
  width: 2px;
  height: 16px;
  overflow: hidden;
}

.audio-ctrl-container-right,
.audio-ctrl-container-center,
.audio-ctrl-container-left {
  width: 20%;
}

.audio-ctrl-container-center {
  text-align: center;
  width: 60%;
}

.audio-ctrl-container-right {
  text-align: right;
  display: inline-flex;
  justify-content: flex-end;
}

.time-stamp-current {
  font-weight: 700;
}

.tooltip-pointer {
  /* position: absolute;
  bottom: -32px; */
  font-size: 40px;
  /* right: 163px; */
  z-index: -1;
}

.popover-sections {
  max-height: 250px;
  width: 350px;
  overflow-y: scroll;
  /* padding: 10px; */
  text-align: left;
  position: relative;
  z-index: 1062;
}

.audio-ctrl-btn-dropdown>span>div>.popover-section-container {
  display: none;
}

.popover-section-label-container-default {
  display: none;
}

.audio-ctrl-btn-dropdown>span>div>.popover-section-label-container-default {
  display: block;
  max-width: 110px;
  max-height: 42px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.sections-btn-for-mobile {
  display: none;
}

.timeline-str {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

/* .popover-section-container:hover {
  background-color: #e2e8ee;
}

.popover-sections>* {
  position: relative;
  z-index: 1062;
} */

.popover-section-container>* {
  position: relative;
  z-index: 1062;
}

.popover-volume {
  /* height: 250px;
  width: 60px; */
  /* overflow-y: scroll; */
  /* padding: 10px; */
  text-align: left;
  width: 260px;
  height: 85px;
  /* margin: 4px 1px 0 0; */
  padding: 8px 8px 13px;
  border-radius: 2px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
  border: solid 1px #b1bdc9;
  background-color: #fff;
}

.nds-popover {
  z-index: 1059;
}

.highlight-annotation-popover {
  visibility: visible;
  margin: 3px 10px 0px 10px;
  color: teal;
  font-size: 12px;
  width: 15px;
}

.hide-highlight-annotation-popover {
  visibility: hidden;
  width: 15px;
  margin: 3px 10px 0px 10px;
}

.popover-section-container {
  display: flex;
  cursor: pointer;
  padding: 8px 12px 8px 8px;
}

.popover-section-label-container {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: flex-start;
  /* margin-bottom: 10px; */
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  font-weight: 400;
}

.nds-option__marker {
  display: none;
}

.popover-section-label-container-highlighted {
  font-weight: 700;
}

.popover-arrow {
  display: "none"
}

.popover-section-title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

@media (max-width: 900px) {
  .audio-ctrl-container-left {
    display: none;
    width: 0%;
  }

  .audio-ctrl-container-center {
    text-align: center;
    width: auto;
  }

  .audio-ctrl-container-right {
    text-align: right;
    display: inline-flex;
    justify-content: flex-end;
    width: auto;
  }
}

@media (max-width: 600px) {
  .audio-ctrl-btn {
    width: 60px;
    margin: 0 2px;
  }

  .play-btn,
  .pause-btn {
    width: 60px;
  }

  .audio-ctrl-btn-center {
    margin: 0 2px;
  }

  .tickmark-btn-container {
    visibility: hidden;
    cursor: pointer;
  }

  .sections-btn-for-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .timeline-str {
    display: none;
  }

  .audio-ctrl-btn-dropdown {
    width: 60px !important;
  }

  .audio-ctrl-btn-dropdown>.nds-button__icon:last-child {
    display: none;
  }
}

@media (max-width: 360px) {
  .audio-ctrl-btn {
    width: 50px;
    margin: 0 2px;
  }

  .play-btn {
    width: 50px;
  }

  .audio-ctrl-btn-center {
    margin: 0 2px;
    width: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/AudioPlayer/AudioPlayer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;gBACc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;kBACgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;GAOG;;AAEH;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;gBACc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;IACzB,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;EACb;AACF","sourcesContent":[".audio-player-container {\n  position: relative;\n  margin-top: 55px;\n  cursor: pointer;\n}\n\n.audio-player-container>* {\n  margin: 0;\n}\n\n.audio-ctrl-btn {\n  /* background-color: #E2E8EE; */\n  border: solid 1px #63768a;\n  background-color: #f2f5f8;\n  color: #243547;\n  width: 60px;\n  margin: 0 5px;\n  font-size: 12px;\n}\n\n.audio-ctrl-btn-dropdown {\n  display: flex !important;\n  flex-direction: row !important;\n  width: 140px !important;\n  height: 58px !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 400 !important;\n}\n\n.audio-ctrl-container-right>.nds-dropdown>.nds-field__info {\n  opacity: 0;\n  height: 0px;\n  width: 0px;\n}\n\n.audio-ctrl-btn:hover {\n  border: solid 1px #63768a;\n  background-color: #e2e8ee;\n}\n\n.audio-ctrl-btn-tooltip-body {\n  /* width: 58px; */\n  /* height: 31px; */\n  padding: 8px 12px;\n  background-color: #e4e4e4;\n  color: #243547;\n  font-size: 12px;\n}\n\n/* .audio-ctrl-btn-tooltip-base {\n  border: 1px solid gray;\n} */\n\n.audio-ctrl-btn-center {\n  border: solid 1px #32475e;\n  background-color: #32475e;\n  width: 60px;\n  color: #FFFFFF;\n  margin: 0 5px;\n  font-size: 12px;\n}\n\n.audio-ctrl-btn-center:hover,\n.play-btn:hover {\n  border: solid 1px #243547;\n  background-color: #243547;\n}\n\n.sections-dropdown-label {\n  opacity: 0;\n  height: 0px;\n  width: 0px;\n}\n\n.play-btn {\n  width: 180px;\n  font-size: 12px;\n  border: solid 1px #32475e;\n  background-color: #32475e;\n  color: #FFFFFF;\n}\n\n.pause-btn {\n  width: 180px;\n  font-size: 12px;\n  background-color: #E2E8EE;\n  color: #243547;\n  border: 1px solid #243547;\n}\n\n.pause-btn:hover {\n  border: solid 1px #63768a;\n  background-color: #ced7e0;\n}\n\n.audio-ctrl-btn,\n.audio-ctrl-btn-center>* {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: center;\n}\n\n.audio-ctrl-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 10px auto;\n}\n\n.audio-slider {\n  border: 0;\n  width: 100%;\n  padding: 40px 0px 0px 0px;\n  background: transparent;\n}\n\n.audio-slider-label {\n  width: 100%;\n  font-weight: 400;\n}\n\n.audio-slider-label-span-container {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.tooltip-label-span {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.tooltip-label-span-timestamp {\n  font-weight: bold;\n}\n\n.tooltip-label-container {\n  margin: 0px;\n  padding: 0 10px;\n  text-align: left;\n  font-size: 14px;\n}\n\n.timeStampContainer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 5px;\n}\n\n.tickmark-btn-container {\n  position: absolute;\n  top: 10px;\n  height: 16px;\n  width: 100%;\n  z-index: 5;\n}\n\n.tickmark-btn {\n  /* height: 15px;\n  width: 10px; */\n  position: absolute;\n  top: -1px;\n  width: 12px;\n  height: 10px;\n  padding: 0px;\n  /* border: none; */\n  font-size: 15px;\n  color: transparent;\n  /* background-color: #BDC4CA; */\n  /* line-height: 15px; */\n  overflow: hidden;\n  /* border-radius: 2px; */\n  z-index: -1;\n  border-radius: 2px;\n  border: solid 1px #475b70;\n  background-color: #ced7e0;\n}\n\n.tickmark-btn:hover {\n  border: solid 1px #475b70;\n  background-color: #63768a;\n}\n\n.tickmark-btn-active {\n  border: solid 1px #196263;\n  background-color: #abe0e0;\n}\n\n.tickmark-btn-text {\n  width: 2px;\n  height: 16px;\n  overflow: hidden;\n}\n\n.audio-ctrl-container-right,\n.audio-ctrl-container-center,\n.audio-ctrl-container-left {\n  width: 20%;\n}\n\n.audio-ctrl-container-center {\n  text-align: center;\n  width: 60%;\n}\n\n.audio-ctrl-container-right {\n  text-align: right;\n  display: inline-flex;\n  justify-content: flex-end;\n}\n\n.time-stamp-current {\n  font-weight: 700;\n}\n\n.tooltip-pointer {\n  /* position: absolute;\n  bottom: -32px; */\n  font-size: 40px;\n  /* right: 163px; */\n  z-index: -1;\n}\n\n.popover-sections {\n  max-height: 250px;\n  width: 350px;\n  overflow-y: scroll;\n  /* padding: 10px; */\n  text-align: left;\n  position: relative;\n  z-index: 1062;\n}\n\n.audio-ctrl-btn-dropdown>span>div>.popover-section-container {\n  display: none;\n}\n\n.popover-section-label-container-default {\n  display: none;\n}\n\n.audio-ctrl-btn-dropdown>span>div>.popover-section-label-container-default {\n  display: block;\n  max-width: 110px;\n  max-height: 42px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.sections-btn-for-mobile {\n  display: none;\n}\n\n.timeline-str {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n/* .popover-section-container:hover {\n  background-color: #e2e8ee;\n}\n\n.popover-sections>* {\n  position: relative;\n  z-index: 1062;\n} */\n\n.popover-section-container>* {\n  position: relative;\n  z-index: 1062;\n}\n\n.popover-volume {\n  /* height: 250px;\n  width: 60px; */\n  /* overflow-y: scroll; */\n  /* padding: 10px; */\n  text-align: left;\n  width: 260px;\n  height: 85px;\n  /* margin: 4px 1px 0 0; */\n  padding: 8px 8px 13px;\n  border-radius: 2px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);\n  border: solid 1px #b1bdc9;\n  background-color: #fff;\n}\n\n.nds-popover {\n  z-index: 1059;\n}\n\n.highlight-annotation-popover {\n  visibility: visible;\n  margin: 3px 10px 0px 10px;\n  color: teal;\n  font-size: 12px;\n  width: 15px;\n}\n\n.hide-highlight-annotation-popover {\n  visibility: hidden;\n  width: 15px;\n  margin: 3px 10px 0px 10px;\n}\n\n.popover-section-container {\n  display: flex;\n  cursor: pointer;\n  padding: 8px 12px 8px 8px;\n}\n\n.popover-section-label-container {\n  display: flex;\n  flex-wrap: nowrap;\n  flex-direction: column;\n  align-items: flex-start;\n  /* margin-bottom: 10px; */\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  cursor: pointer;\n  font-weight: 400;\n}\n\n.nds-option__marker {\n  display: none;\n}\n\n.popover-section-label-container-highlighted {\n  font-weight: 700;\n}\n\n.popover-arrow {\n  display: \"none\"\n}\n\n.popover-section-title {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n@media (max-width: 900px) {\n  .audio-ctrl-container-left {\n    display: none;\n    width: 0%;\n  }\n\n  .audio-ctrl-container-center {\n    text-align: center;\n    width: auto;\n  }\n\n  .audio-ctrl-container-right {\n    text-align: right;\n    display: inline-flex;\n    justify-content: flex-end;\n    width: auto;\n  }\n}\n\n@media (max-width: 600px) {\n  .audio-ctrl-btn {\n    width: 60px;\n    margin: 0 2px;\n  }\n\n  .play-btn,\n  .pause-btn {\n    width: 60px;\n  }\n\n  .audio-ctrl-btn-center {\n    margin: 0 2px;\n  }\n\n  .tickmark-btn-container {\n    visibility: hidden;\n    cursor: pointer;\n  }\n\n  .sections-btn-for-mobile {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .timeline-str {\n    display: none;\n  }\n\n  .audio-ctrl-btn-dropdown {\n    width: 60px !important;\n  }\n\n  .audio-ctrl-btn-dropdown>.nds-button__icon:last-child {\n    display: none;\n  }\n}\n\n@media (max-width: 360px) {\n  .audio-ctrl-btn {\n    width: 50px;\n    margin: 0 2px;\n  }\n\n  .play-btn {\n    width: 50px;\n  }\n\n  .audio-ctrl-btn-center {\n    margin: 0 2px;\n    width: 50px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
